// @core/api/endpoints/workflow/create_environment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEnvironmentRequest,
  PipelineEnvironmentResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create environment
 * Creates a deployment environment (dev/staging/prod) with credential bindings for a pipeline.
 */
export async function CreateEnvironment(
  pipeline_id: string,
  data: CreateEnvironmentRequest,
  options?: RequestOptions
): Promise<PipelineEnvironmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/environments`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineEnvironmentResponse>(requestPath, data, requestOptions);
}
